module.exports = __webpack_public_path__ + "media/images/admin/icons/align-right-08dcc004b6be422dffa2095de65cb42c.svg";